import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import manageFocus from '@bibliocommons/base-accessibility-manage-focus';
import InlineOverlayContext from 'app/components/shared/InlineOverlay/InlineOverlayContext';
import './InlineOverlay.scss';

export class InlineOverlay extends React.PureComponent {
  componentDidMount() {
    this.props.captureFocus(this._element, false);
  }

  componentWillUnmount() {
    this.props.restoreFocus();
  }

  render() {
    const { className, children, testId } = this.props;
    const contextValue = { handleClose: this.props.handleClose };
    return (
      <div
        className={cn('cp-inline-overlay', className)}
        data-test-id={testId}
        ref={el => {
          this._element = el;
        }}
      >
        <InlineOverlayContext.Provider value={contextValue}>{children}</InlineOverlayContext.Provider>
      </div>
    );
  }
}

InlineOverlay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  captureFocus: PropTypes.func,
  restoreFocus: PropTypes.func
};

InlineOverlay.displayName = 'InlineOverlay';

export default manageFocus(InlineOverlay);
